import landing from './landing'
import accountActivation from './accountActivation'
import passwordReset from './passwordReset'
import { Module } from 'types'

export default [landing, accountActivation, passwordReset] as Module[]
